import { MenuItem as MuiMenuItem, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

export function MenuItem({
  onClick,
  text,
  sx,
  sxText
}: {
  onClick?: () => void;
  text: string;
  sx?: SxProps<Theme>;
  sxText?: SxProps<Theme>;
}) {
  return (
    <MuiMenuItem
      onClick={onClick}
      sx={{
        backgroundColor: theme => theme.brandPalette.background.neutral,
        padding: theme => theme.spacing(3, 5),
        ...sx
      }}
    >
      <Typography variant="labelSmall" textAlign="center" sx={{ ...sxText }}>
        {text}
      </Typography>
    </MuiMenuItem>
  );
}
